<app-chart-layout
    [subtitle]="computedStatistic().description ?? ''"
    [title]="computedStatistic().name">
    <div class="flex flex-row items-center gap-2">
        <div
            class="relative w-full max-w-full overflow-x-auto mt-4"
            id="chart">
            <app-base-chart
                [isHeightClassApplied]="false"
                [isMapExpanded]="isExpanded()"
                [options]="options()" />

            @if (hoverTitleInformation()) {
                <div class="custom-legend">
                    <p
                        class="text-xl p-2 text-end"
                        [style.color]="hoverTitleInformationColor()">
                        {{ hoverTitleInformation() }}
                    </p>
                    <p class="text-on-surface p-2 text-end">{{ hoverSubtitleInformation() }}</p>
                </div>
            }
        </div>
    </div>
</app-chart-layout>
